module.exports = __webpack_public_path__ + "img/group26@2x.71618c03.png";